import {
  CRM_DATA_ENGINE_METRICS_OPERAND,
  CRM_DATA_ENGINE_NUMBER_OPERAND,
  CRM_DATA_ENGINE_OPERAND_TYPE,
  DATA_ELEMENT_TYPE,
  FIELD_TYPE,
  STUDIO_DATA_TYPE
} from "@/static/global-variables";

class ValidatorUtil {
  isValidEditElement(obj) {
    let isValid = false;
    if (obj) {
      switch (obj.type) {
        case DATA_ELEMENT_TYPE.CONTEXT_QUERY:
          isValid = this.isValidContexElement(obj);
          break;
        case DATA_ELEMENT_TYPE.CRM_QUERY:
          isValid = this.isValidCrmElement(obj);
          break;
        case DATA_ELEMENT_TYPE.ONE_FOR_ONE:
          isValid = this.isValidOneForOneElement(obj);
          break;
        case DATA_ELEMENT_TYPE.SUMMARIZE:
          break;
        case DATA_ELEMENT_TYPE.OBJECT_TRANSLATION:
          break;
        case DATA_ELEMENT_TYPE.FIELD_TRANSLATION:
          break;
        case DATA_ELEMENT_TYPE.VEEVA_MESSAGES:
          break;
        case DATA_ELEMENT_TYPE.SORT_LIST:
          break;
        case DATA_ELEMENT_TYPE.FILTER_LIST:
          break;
        case DATA_ELEMENT_TYPE.SUBLIST:
          break;
        case DATA_ELEMENT_TYPE.NITRO_QUERY:
          isValid = this.isValidCrmElement(obj);
          break;
        case DATA_ELEMENT_TYPE.SALES_DATA_QUERY:
          isValid = this.isValidSalesDataElement(obj);
          break;
        case DATA_ELEMENT_TYPE.CRM_DATA_ENGINE:
          isValid = this.isValidCrmDataEngineElement(obj);
          break;
      }
    }
    return isValid;
  }

  formatDataElement(obj) {
    let formatted;
    if (obj) {
      switch (obj.type) {
        case DATA_ELEMENT_TYPE.CONTEXT_QUERY:
          formatted = this.formatContextDataElement(obj);
          break;
        case DATA_ELEMENT_TYPE.CRM_QUERY:
          formatted = this.formatCrmDataElement(obj);
          break;
        case DATA_ELEMENT_TYPE.ONE_FOR_ONE:
          formatted = this.formatOneForOneDataElement(obj);
          break;
        case DATA_ELEMENT_TYPE.SUMMARIZE:
          break;
        case DATA_ELEMENT_TYPE.OBJECT_TRANSLATION:
          break;
        case DATA_ELEMENT_TYPE.FIELD_TRANSLATION:
          break;
        case DATA_ELEMENT_TYPE.VEEVA_MESSAGES:
          break;
        case DATA_ELEMENT_TYPE.SORT_LIST:
          break;
        case DATA_ELEMENT_TYPE.FILTER_LIST:
          break;
        case DATA_ELEMENT_TYPE.SUBLIST:
          break;
        case DATA_ELEMENT_TYPE.NITRO_QUERY:
          // remove label from data element json and cache
          delete obj.object.label;
          formatted = this.formatCrmDataElement(obj);
          break;
        case DATA_ELEMENT_TYPE.SALES_DATA_QUERY:
          formatted = this.formatSalesDataElement(obj);
          break;
        case DATA_ELEMENT_TYPE.CRM_DATA_ENGINE:
          delete obj.object.label;
          formatted = this.formatCrmDataEngineElement(obj);
          break;
      }
    }
    return formatted;
  }

  isValidOneForOneElement(obj) {
    let isValid = false;
    if (
      obj.selectedSource &&
      obj.expresionFields &&
      obj.expresionFields.length
    ) {
      isValid = !obj.expresionFields.some(
        e => !e.userLabel || !e.confExpression || e.isEmpty
      );
      if (isValid) {
        // verify unique userLabels
        const labels = obj.expresionFields.map(v =>
          v.userLabel ? v.userLabel.toLowerCase() : ""
        );
        isValid =
          !labels.includes("") && labels.length === new Set(labels).size;
      }
    }
    return isValid;
  }

  formatOneForOneDataElement(obj) {
    const formattedFields = {};
    obj.expresionFields.forEach(item => {
      formattedFields[item.userLabel] = item.confExpression;
    });
    return {
      appId: obj.appId,
      de: {
        id: obj.id,
        description: obj.description,
        name: obj.name,
        type: obj.type,
        original: obj.selectedSource.id,
        originLabel: obj.selectedSource.name,
        fields: formattedFields
      }
    };
  }

  isValidCrmElement(obj) {
    let isValid = false;
    if (obj) {
      isValid = Boolean(
        obj.object && obj.selectedItems && obj.selectedItems.length
      );
      if (
        isValid &&
        Object.keys(obj.where).length &&
        obj.where.subclauses.length
      ) {
        isValid =
          obj.where.subclauses.length === 1 && !obj.where.subclauses[0].id
            ? false
            : this.isValidWhere(obj.where);
      }
      if (isValid && obj.sort && obj.sort.length) {
        isValid = this.isValidSort(obj.sort);
      }
    }
    return isValid;
  }

  isValidCrmDataEngineWhere(where) {
    if (where.type === "all_of" || where.type === "any_of") {
      return where.conditions
        .map(childWhere => this.isValidCrmDataEngineWhere(childWhere))
        .every(Boolean);
    }
    if (!where.type) {
      return false;
    }
    const whereType =
      typeof where.type === "string" || where.type instanceof String
        ? where.type
        : where.type.value;

    switch (whereType) {
      case "in":
        return !!(where.field && where.type && where.values);
      case "between":
        return !!(
          where.field &&
          where.type &&
          where.startValue &&
          where.endValue
        );
      case "is_null":
        return !!(where.field && where.type);
      case "is_not_null":
        return !!(where.field && where.type);
      default:
        return !!(where.field && where.type && where.value);
    }
  }

  isValidCrmDataEngineElement(obj) {
    if (!obj) {
      return false;
    }
    if (!(obj.object && obj.selectedItems && obj.selectedItems.length)) {
      return false;
    }
    if (!this.isValidCalculatedFields(obj.calFields)) {
      return false;
    }
    if (
      obj.where.conditions &&
      obj.where.conditions.length &&
      !this.isValidCrmDataEngineWhere(obj.where)
    ) {
      return false;
    }
    return !(obj.sort && obj.sort.length && !this.isValidSort(obj.sort));
  }
  isValidCalculatedFields(calFields) {
    let isValid = true;

    if (!calFields) {
      return isValid;
    }

    for (const cf of calFields) {
      isValid = Boolean(
        cf.type &&
          cf.as &&
          (cf.field ||
            (cf.fieldA && cf.fieldB) ||
            (cf.arguments &&
              cf.arguments.length > 0 &&
              cf.arguments.every(a => {
                return (a.name || a.value) && !a.isEmpty;
              })))
      );
      if (isValid) {
        if (cf.type === CRM_DATA_ENGINE_OPERAND_TYPE.DATE_TRUNC) {
          isValid = Boolean(cf.field && cf.interval);
        }
      }

      if (!isValid) {
        break;
      }
    }
    return isValid;
  }
  isValidWhere(where) {
    let isValid = true;
    if (where) {
      isValid = Boolean(
        where.type && where.type.value && where.subclauses.length
      );
      if (isValid) {
        for (const el of where.subclauses) {
          if (el.id) {
            // where clause
            isValid = Boolean(
              el.field &&
                el.field.name &&
                el.type &&
                el.type.value &&
                el.expression &&
                !el.expression.isEmpty
            );
          } else {
            // this is a group
            isValid = this.isValidWhere(el);
          }
          if (!isValid) {
            break;
          }
        }
      }
    }
    return isValid;
  }

  isValidSort(sort) {
    let isValid = true;
    if (sort) {
      isValid = !sort.some(e => !e.key || !e.sortDir);
    }
    return isValid;
  }

  formatCrmDataElement(obj) {
    let formattedFields = {};

    obj.selectedItems.forEach(item => {
      formattedFields[item.name] = {
        dataType: item.type,
        label: item.label,
        isPicklist: item.isPicklist
          ? item.isPicklist
          : item.originalType === FIELD_TYPE.PICKLIST ||
            item.originalType === FIELD_TYPE.MULTI_SELECT_PICKLIST
      };
    });

    const de = {
      id: obj.id,
      type: obj.type,
      name: obj.name,
      description: obj.description,
      object: obj.object,
      fields: formattedFields
    };
    if (obj.limit && obj.limit > 0) {
      de.limit = Number(obj.limit);
    }
    if (obj.sort && obj.sort.length) {
      de.sort = obj.sort;
    }
    if (obj.where && obj.where.subclauses && obj.where.subclauses.length) {
      de.where = obj.where;
    }
    if (de.type === DATA_ELEMENT_TYPE.NITRO_QUERY) {
      delete de.object.columns;
    }

    return {
      appId: obj.appId,
      de
    };
  }

  formatCrmDataEngineElement(obj) {
    let pureFields = obj.selectedItems.map(item => {
      return {
        type: "field",
        field: item.name,
        dataType: item.type,
        label: item.label
      };
    });

    let calFields = obj.calFields.map(item => {
      if (CRM_DATA_ENGINE_METRICS_OPERAND.includes(item.type)) {
        return {
          as: item.as,
          label: item.as,
          type: item.type,
          field: item.field.name,
          dataType: item.field.type
        };
      } else if (CRM_DATA_ENGINE_NUMBER_OPERAND.includes(item.type)) {
        return {
          as: item.as,
          label: item.as,
          type: item.type,
          fieldA: item.fieldA.name,
          fieldB: item.fieldB.name,
          dataType: item.fieldA.type
        };
      } else if (item.type === CRM_DATA_ENGINE_OPERAND_TYPE.DATE_TRUNC) {
        return {
          as: item.as,
          label: item.as,
          type: item.type,
          field: item.field.name,
          interval: item.interval.key,
          dataType: item.field.type
        };
      } else if (item.type === CRM_DATA_ENGINE_OPERAND_TYPE.CONCAT) {
        let formatted = item.arguments.map(a => {
          return a.type === "static" ? { text: a.value } : a.name;
        });
        return {
          as: item.as,
          label: item.as,
          type: item.type,
          dataType: STUDIO_DATA_TYPE.STRING,
          arguments: formatted
        };
      }
    });

    const de = {
      id: obj.id,
      type: obj.type,
      name: obj.name,
      description: obj.description,
      table: obj.object.name,
      fields: pureFields.concat(calFields),
      calFields: obj.calFields
    };
    if (obj.limit && obj.limit > 0) {
      de.limit = Number(obj.limit);
    }
    if (obj.sort && obj.sort.length) {
      de.sort = obj.sort;
    }
    if (obj.where && obj.where.conditions && obj.where.conditions.length) {
      de.where = obj.where;
    }

    return {
      appId: obj.appId,
      de
    };
  }

  formatSalesDataElement(obj) {
    const de = {
      id: obj.id,
      type: obj.type,
      description: obj.description,
      name: obj.name,
      scale: obj.scale,
      dataType: obj.dataType,
      accountIds: obj.accountIds,
      startDate: obj.startDate,
      endDate: obj.endDate
    };
    if (obj.limit && obj.limit > 0) {
      de.limit = Number(obj.limit);
    }
    if (obj.sort && obj.sort.length) {
      de.sort = obj.sort;
    }

    return {
      appId: obj.appId,
      de
    };
  }

  isValidContexElement(obj) {
    return Boolean(obj.selectedObject && obj.selectedField);
  }

  formatContextDataElement(obj) {
    const formattedFields = {
      [obj.selectedField.name]: {
        dataType: obj.selectedField.type,
        name: obj.selectedField.name,
        label: obj.selectedField.label,
        type: obj.selectedField.type
      }
    };

    const selectedField = {
      name: obj.selectedField.name,
      label: obj.selectedField.label,
      type: obj.selectedField.type,
      dataType: obj.selectedField.dataType
    };

    return {
      appId: obj.appId,
      de: {
        id: obj.id,
        description: obj.description,
        name: obj.name,
        type: obj.type,
        object: obj.selectedObject.name,
        fields: formattedFields,
        selectedField: selectedField
      }
    };
  }

  isValidSublist(obj) {
    return Boolean(
      obj &&
        obj.selectedSource &&
        obj.skip !== "" &&
        obj.skip !== null &&
        obj.keep !== "" &&
        obj.keep !== null
    );
  }

  formatSublist(obj) {
    return {
      name: obj.name,
      description: obj.description,
      original: obj.selectedSource.id,
      originLabel: obj.selectedSource.label,
      type: obj.type,
      skip: Number(obj.skip),
      keep: Number(obj.keep)
    };
  }

  isValidSortList(obj) {
    let isValid = false;
    if (obj && obj.selectedSource && obj.sort && obj.sort.length) {
      isValid = !obj.sort.some(e => !e.expression || !e.valid || !e.sortDir);
    }
    return isValid;
  }

  formatSortList(obj) {
    const sort = [];
    for (const el of obj.sort) {
      sort.push({
        expression: el.expression,
        sortDir: {
          value: el.sortDir
        }
      });
    }
    return {
      description: obj.description,
      name: obj.name,
      original: obj.selectedSource.id,
      originLabel: obj.selectedSource.label,
      type: obj.type,
      sort: sort
    };
  }

  isValidMergeList(obj) {
    const labelList = [];
    if (obj && obj.selectedSources && obj.fieldLabels) {
      for (const datasource of obj.selectedSources) {
        if (datasource.isEmpty) {
          return false;
        }
      }
      for (const fieldLabel of obj.fieldLabels) {
        if (fieldLabel.isEmpty || !fieldLabel.label) {
          return false;
        }
        if (labelList.includes(fieldLabel.label)) {
          return false;
        }
        labelList.push(fieldLabel.label);
        for (const fieldListElement of fieldLabel.fieldList) {
          if (fieldListElement.isEmpty) {
            return false;
          }
        }
      }
      return obj.selectedSources.length !== 0 && obj.fieldLabels.length !== 0;
    }
    return false;
  }

  formatMergeList(obj) {
    const sources = [];
    const fieldOrder = obj.fieldLabels.map(element => {
      return { label: element.label, fieldType: element.fieldType };
    });
    obj.selectedSources.forEach((datasource, dataSourceIndex) => {
      const sourceDict = {};
      sourceDict.dataSource = datasource.id;
      sourceDict.dict = {};
      obj.fieldLabels.forEach(field => {
        if (!field.isEmpty) {
          sourceDict.dict[field.label] = field.fieldList[dataSourceIndex].name;
        }
      });
      sources.push(sourceDict);
    });
    return {
      description: obj.description,
      name: obj.name,
      type: obj.type,
      sources: sources,
      fieldOrder: fieldOrder
    };
  }

  isValidFilterList(obj) {
    return Boolean(obj && obj.selectedSource && obj.filter && obj.filter.valid);
  }

  formatFilterList(obj) {
    const filter = { ...obj.filter };
    delete filter.valid;
    return {
      name: obj.name,
      description: obj.description,
      original: obj.selectedSource.id,
      originLabel: obj.selectedSource.label,
      type: obj.type,
      filter: filter
    };
  }

  isValidSalesDataElement(obj) {
    let isValid = false;
    if (obj) {
      isValid = Boolean(obj.scale && obj.dataType && obj.accountIds);
      if (isValid && obj.sort && obj.sort.length) {
        isValid = this.isValidSort(obj.sort);
      }
      if (isValid && obj.limit) {
        const limitNumber = Number.parseInt(obj.limit);
        isValid = Number.isInteger(limitNumber) && obj.limit > 0;
      }
    }
    return isValid;
  }
}

export default new ValidatorUtil();
